import transport from '@/plugins/transport.js'

export default {
    transport,
}
